export const scrollToErrorElement = (wrapper: HTMLDivElement | null) => {
  const elementWithError = wrapper?.querySelector('[class*="error"]');
  if (!elementWithError) return;

  elementWithError.scrollIntoView({
    block: 'start',
    behavior: 'smooth',
  });
};
